import { render, staticRenderFns } from "./companyheader.vue?vue&type=template&id=5afc42cb&scoped=true&"
import script from "./companyheader.vue?vue&type=script&lang=js&"
export * from "./companyheader.vue?vue&type=script&lang=js&"
import style0 from "./companyheader.vue?vue&type=style&index=0&id=5afc42cb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afc42cb",
  null
  
)

export default component.exports